import request from '../request'

export const getDevelopmentalRubrics = (curriculumId, filter) =>
  request.post(`/assessment/${curriculumId}/developmental-rubrics/list`, { filter }).then((res) => res)

export const getDevelopmentalRubricsGantt = (curriculumId, filter) =>
  request.post(`/assessment/${curriculumId}/developmental-rubrics/gantt`, { filter }).then((res) => res)

export const getDevelopmentalRubricsSkipLimit = (curriculumId, skip = 0, limit = 5, filter) =>
  request
    .post(`/assessment/${curriculumId}/developmental-rubrics/list/skip/${skip}/limit/${limit}`, { filter })
    .then((res) => res)

export const getDevelopmentalRubricsGroupedByLearningContinuum = (curriculumId, filter) =>
  request
    .post(`/assessment/${curriculumId}/developmental-rubrics/grouped-by-learning-continuum`, { filter })
    .then((res) => res)

export const getDevelopmentalRubricById = (curriculumId, id) =>
  request.get(`/assessment/${curriculumId}/developmental-rubrics/${id}`).then((res) => res)

export const createDevelopmentalRubric = (curriculumId, data) =>
  request.post(`/assessment/${curriculumId}/developmental-rubrics`, data).then((res) => res)

export const cloneDevelopmentalRubric = (curriculumId, id) =>
  request.post(`/assessment/${curriculumId}/developmental-rubrics/${id}/clone`).then((res) => res)

export const updateDevelopmentalRubric = (curriculumId, id, type, data) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/${id}/${type}`, data).then((res) => res)

export const linkDevelopmentalRubric = (curriculumId, id) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/${id}/link`).then((res) => res)

export const unlinkDevelopmentalRubric = (curriculumId, id) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/${id}/unlink`).then((res) => res)

export const unlinkDevelopmentalRubricFromClass = (curriculumId, id, classId) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/${id}/unlink/${classId}`).then((res) => res)

export const archiveDevelopmentalRubric = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/developmental-rubrics/${id}/archive`).then((res) => res)

export const deleteDevelopmentalRubric = (curriculumId, id) =>
  request.delete(`/assessment/${curriculumId}/developmental-rubrics/${id}`).then((res) => res)

export const updateDevelopmentalRubricBatch = (curriculumId, type, data) =>
  request.put(`/assessment/${curriculumId}/developmental-rubrics/batch/${type}`, data).then((res) => res)
